import PolicyEditor from 'components/PolicyEditor/PolicyEditor';
import { useGetPrivacyPolicyQuery, useUpdatePrivacyPolicyMutation } from '../../api/api';

const PrivacyPolicyPage = () => {
  const { data: privacyPolicy } = useGetPrivacyPolicyQuery();
  const [updatePrivacyPolicy, { isLoading }] = useUpdatePrivacyPolicyMutation();

  const handleUpdate = async (markdown: string) => {
    await updatePrivacyPolicy(markdown).unwrap();
  };

  return (
    <PolicyEditor
      title="Privacy Policy"
      initialText={privacyPolicy?.text}
      onUpdate={handleUpdate}
      isLoading={isLoading}
    />
  );
};

export default PrivacyPolicyPage;